import { Dayjs } from 'dayjs';

type StringExtractor<T> = (obj: T) => string;
type NumberExtractor<T> = (obj: T) => number;
type DateExtractor<T> = (obj: T) => Date;
type DayjsExtractor<T> = (obj: T) => Dayjs;

type Extractor<T> = StringExtractor<T> | NumberExtractor<T> | DateExtractor<T> | DayjsExtractor<T>;

export function ascending<T> (...selectors: Array<Extractor<T>>): (a: T, b: T) => number {
	return (a, b) => {
		const [selector, ...rest] = selectors;

		const first = selector(a) || '';
		const second = selector(b) || '';

		if (first === second) {
			if (rest.length > 0) {
				return ascending(...rest)(a, b);
			} else {
				return 0;
			}
		} else {
			return first < second ? -1 : 1;
		}
	};
}

export function descending<T> (picker: Extractor<T>): (a: T, b: T) => number {
	return (a, b) => 0 - ascending(picker)(a, b);
}

export function sort<T> (array: T[], ...selector: Array<Extractor<T>>): T[] {
	return array.sort(ascending(...selector));
}
